export const MAP_CONFIG = {
  DEFAULT_CENTER: [55.6761, 12.5683] as [number, number], // Copenhagen, Denmark
  DEFAULT_ZOOM: 12,
  MIN_ZOOM: 3,
  MAX_ZOOM: 19,
  ZOOM_DELTA: 0.5,
  ZOOM_SNAP: 0.5,
  WHEEL_PX_PER_ZOOM_LEVEL: 120,
  TILE_URL: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  TILE_ATTRIBUTION:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  SATELLITE_TILE_URL:
    "https://wayback.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/WMTS/1.0.0/default028mm/MapServer/tile/41468/{z}/{y}/{x}",
  SATELLITE_TILE_ATTRIBUTION: "&copy; Esri",
} as const;

export const BIKE_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  MAINTENANCE: "maintenance",
} as const;

export const UNCATEGORIZED_FILTER_VALUE = "__UNCATEGORIZED__";
export const NO_MAIN_CITY_FILTER_VALUE = "__NO_MAIN_CITY__";

export const COLORS = {
  PRIMARY: "#3b82f6",
  SUCCESS: "#22c55e",
  WARNING: "#f59e0b",
  DANGER: "#ef4444",
  GRAY: "#6b7280",
} as const;

export const BIKE_MARKER_COLORS = {
  ACTIVE_MOVING: "#22c55e", // Green
  ACTIVE_STOPPED: "#f59e0b", // Yellow
  INACTIVE: "#6b7280", // Gray
  MAINTENANCE: "#ef4444", // Red
} as const;

export const REFRESH_INTERVALS = {
  BIKE_MARKERS: 30000, // 30 seconds
  REAL_TIME: 5000, // 5 seconds
  STATISTICS: 60000, // 1 minute
} as const;

export const API_ENDPOINTS = {
  BIKES: "/api/v1/bikes",
  GPS: "/api/v1/gps",
  MAPS: "/api/v1/maps",
  WEBHOOKS: "/webhooks",
} as const;

/**
 * Trip-split / route analytics thresholds.
 * TIME_GAP_MINUTES mirrors backend GPS_DATA_GAP_THRESHOLD.
 * Teleport rules must stay aligned with backend VEHICLE_STATS outlier filters.
 */
export const ROUTE_THRESHOLDS = {
  TIME_GAP_MINUTES: 30,
  STOP_SPEED_KMH: 1,
  STOP_DURATION_MINUTES: 5,
  SLOW_SPEED_KMH: 5,
  /** Default implied-speed teleport ceiling when no vehicle max is configured */
  TELEPORT_MAX_SPEED_KMH: 160,
  /** Applied to vehicle/category max_speed when resolving teleport ceiling */
  TELEPORT_SPEED_MULTIPLIER: 1.5,
  /** Floor when scaling from a low vehicle max (avoids tiny ceilings) */
  TELEPORT_SPEED_FLOOR_KMH: 40,
  /** Ignore implied-speed teleport below this distance (GPS jitter / multipath) */
  TELEPORT_MIN_DISTANCE_KM: 0.5,
  /** Skip implied-speed teleport when Δt is at or below this (duplicate/jitter) */
  TELEPORT_MIN_INTERVAL_SECONDS: 15,
  GPS_POINTS_MARKER_THRESHOLD: 300,
  GAP_ANIMATION_STEPS_MIN: 8,
  GAP_ANIMATION_STEPS_MAX: 24,
} as const;
